import { render, staticRenderFns } from "./NoProducts.vue?vue&type=template&id=1fd62eb2&scoped=true&"
import script from "./NoProducts.vue?vue&type=script&lang=js&"
export * from "./NoProducts.vue?vue&type=script&lang=js&"
import style0 from "./NoProducts.vue?vue&type=style&index=0&id=1fd62eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd62eb2",
  null
  
)

export default component.exports